import React from 'react';
import PropTypes from 'prop-types';
import { Table, TableBody, TableRow, TableCell, Grid } from '@material-ui/core';

const UserPersonalData = props => {
    const { record } = props;

    if (!record) return null;

    return (
        <div>
            <Table>
                <TableBody>
                    <TableRow>
                        <TableCell>English Name</TableCell>
                        <TableCell style={{ textAlign: 'right' }}>
                            {record.englishName || '-'}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Arabic Name</TableCell>
                        <TableCell style={{ textAlign: 'right' }}>
                            {record.arabicName || '-'}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>First Name (English)</TableCell>
                        <TableCell style={{ textAlign: 'right' }}>
                            {record.firstNameEnglish || '-'}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>First Name (Arabic)</TableCell>
                        <TableCell style={{ textAlign: 'right' }}>
                            {record.firstNameArabic || '-'}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Last Name (English)</TableCell>
                        <TableCell style={{ textAlign: 'right' }}>
                            {record.lastNameEnglish || '-'}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Last Name (Arabic)</TableCell>
                        <TableCell style={{ textAlign: 'right' }}>
                            {record.lastNameArabic || '-'}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Nickname (English)</TableCell>
                        <TableCell style={{ textAlign: 'right' }}>
                            {record.nicknameEnglish || '-'}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Nickname (Arabic)</TableCell>
                        <TableCell style={{ textAlign: 'right' }}>
                            {record.nicknameArabic || '-'}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Gender</TableCell>
                        <TableCell style={{ textAlign: 'right' }}>
                            {record.gender || '-'}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Current Status</TableCell>
                        <TableCell style={{ textAlign: 'right' }}>
                            {record.currentStatus || '-'}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Language</TableCell>
                        <TableCell style={{ textAlign: 'right' }}>
                            {record.language || '-'}
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </div>
    );
};

UserPersonalData.propTypes = {
    record: PropTypes.object,
};

export default UserPersonalData;
